import axios from "axios";
import router from "../router/index";

const baseAPI = axios.create({
  // baseURL: "http://localhost:30006/",
  // baseURL: "http://localhost:30006/",// qwertyui
  baseURL: "https://baicserver.baicuae.com/",
});

baseAPI.interceptors.response.use(
  (response) => {
    if (response.data.status === false && response.data.message === "jwt expired") {
      console.log("JWT expired, logging out...");

      // Remove user data
      localStorage.removeItem("token");
      localStorage.removeItem("email");

      // Redirect to sign-in page
      setTimeout(() => {
        router.push("/sign-in").catch((err) => console.error("Router error:", err));
      }, 100);
    }
    return response;
  });

export default baseAPI;
